package com.veldekar.pages.log

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.PageContext
import com.veldekar.components.layouts.SessionPageLayout
import com.veldekar.components.logs.Log_2025_05_17_Day_1
import com.veldekar.components.widgets.SessionDayHeader
import kotlinx.datetime.LocalDate

@Page(routeOverride = "/2025-05-17")
@Composable
public fun Log_2025_05_17(ctx: PageContext) {
    SessionPageLayout(
        ctx = ctx,
        title = "Fairy Rejects Proposal of Giant Hermaphrodite Eel",
        ogTitle = "Fairy Rejects Proposal of Giant Hermaphrodite Eel",
        date = LocalDate(2_025, 5, 17),
        aiHint = "Image, title, and description are a joke.",
        ogDescription = "While Tuesday appreciates being seen, he could never live in a subterranean cavern. He needs to fly through the trees of the forest.",
        ogImage = "images/beMine.webp",
        ogImageWidth = 1_200,
        ogImageHeight = 630,
        ogImageAlt = "A pink heart with the text 'BE MINE' in bold red letters on a black background. Representing a Valentine's Day candy.",
    ) {
        SessionDayHeader(dayId = "shimmer-5", dateString = "Shimmer 5")
        Log_2025_05_17_Day_1()
    }
}
